import React from 'react';
import { Select, SelectItem } from '@heroui/react';

interface FilterSelectProps {
  label: string;
  value: string;
  options: Array<{ key: string; label: string }>;
  onChange: (value: string) => void;
  className?: string;
}

export function FilterSelect({ label, value, options, onChange, className = 'w-36' }: FilterSelectProps) {
  // Normalize value: empty string or 'all' should show as 'all' (no selection)
  const normalizedValue = !value || value === 'all' ? 'all' : value;
  
  return (
    <Select
      aria-label={`${label} filter`}
      className={className}
      label={label}
      selectedKeys={normalizedValue === 'all' ? new Set([]) : new Set([normalizedValue])}
      selectionMode="single"
      size="sm"
      onSelectionChange={(keys) => {
        const selectedKey = Array.from(keys as Set<string>)[0];
        const val = selectedKey || 'all';
        onChange(val);
      }}
    >
      {options.map((option) => (
        <SelectItem key={option.key}>{option.label}</SelectItem>
      ))}
    </Select>
  );
}

export default FilterSelect;
